module.exports = __webpack_public_path__ + "img/图片19.4e45ba1d.png";